import React, { useState } from 'react'
import ModalUI from '../../components/modalUI/ModalUI'
import ButtonUI from '../../components/button/buttons';
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SnackBar from '../../components/notification/snackbar/snackbar';
import { TableBlackListCard } from './table';
import { FormBlackListCard } from './formBlackList';
import { ModalDeleteCard } from './modalDeleteCard';
import { useDeleteBlackListCardMutation } from '../../service/useBlackListCard/useBlackListCard';

export const BlackListCard = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);

  const [openModalDelete, setOpenModalDelete] = useState(false);

  const [snackMessage, setSnackMessage] = useState('');
  const [snackSeverity, setSnackSeverity] = useState<'success' | 'error' | 'info' | 'warning'>('success');
  const [refreshTableCount, setRefreshTableCount] = useState(0);

  const [numberCard, setNumberCard] = useState('')

  const handleOpenModal = () => {
    setOpenModal(true);

  };

  const handleCloseModal = () => {
    setOpenModal(false);

  };


  const [deleteBlackListCard, { isLoading }] = useDeleteBlackListCardMutation();

  const handleDeleteCard = async () => {
    try {
      
      const res = await deleteBlackListCard(numberCard).unwrap();

      setSnackMessage("Tarjeta desbloqueada");
      setSnackSeverity("success");
      setOpenSnack(true);

      setRefreshTableCount(prev => prev + 1);
      setOpenModalDelete(false);
    } catch (error) {
      setSnackMessage("Error al desbloquear");
      setSnackSeverity("error");
      setOpenSnack(true);
    }
  };


  return (
    <div>
      <h2>Bloqueo de tarjetas</h2>

      <ButtonUI
        icon={<AddCircleOutlineIcon />}
        onClick={() => handleOpenModal()}
        size="small"
        color="primary"
        variant="outlined"
        title="Agregar tarjeta"
      />
      <TableBlackListCard refresh={refreshTableCount} setData={setNumberCard}  onOpen={setOpenModalDelete}/>
      <ModalUI children={<FormBlackListCard onFinished={({ success, message, severity }) => {
        setSnackMessage(message);
        setSnackSeverity(severity || (success ? 'success' : 'error'));
        setOpenSnack(true);
        if (success) {
          //setRefreshTableCount(prev => prev + 1);
          handleCloseModal();
        }
      }} handleCloseModal={handleCloseModal} />} setOpen={setOpenModal} open={openModal} />

      <SnackBar open={openSnack} message={snackMessage} severity={snackSeverity} onClose={() => setOpenSnack(false)} />
      <ModalUI children={<ModalDeleteCard setOpenModal={setOpenModalDelete} onConfirm={handleDeleteCard} loading={isLoading} />}
        setOpen={setOpenModalDelete}
        open={openModalDelete} />

    </div>
  )
}
